import { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { useParams } from "react-router-dom";
import { Label, TextInput } from "flowbite-react";
import { useGetData } from "../../../../../hooks/useGetData";
import { EvaluadoInterface } from "../../../../../interfaces/EvaluadoInterface";
import { FechasInterface } from "../../../../../interfaces/FechasInterface";
import { ReferenciasLaboralesInterface } from "../../../../../interfaces/ReferenciasLaboralesInterface";
import { NotasRLInterface } from "../../../../../interfaces/NotasRLInterface";
import BarraReferenciaL from "../../../../../img/Barra_ReferenciaL.png";
import HeaderPrint from "../../../../../components/HeaderFormsPrint/HeaderFormsPrint";
import fotoMapa from "../../../../../img/fotoMapa.png";

export const LaboralesListaPrint = () => {
  const tituloFormulario = "REFERENCIAS LABORALES";
  const { control, handleSubmit, setValue, reset } = useForm();
  const { evaluadosList_id } = useParams<{ evaluadosList_id: string }>();
  const [edad, setEdad] = useState<number | null>(null);
  const [fechaNacimiento, setFechaNacimiento] = useState<string>("");

  const formFields = [
    { label: "EMPRESA:", id: "empresa" },
    { label: "DOMICILIO:", id: "domicilio" },
    { label: "TELÉFONO:", id: "telefono" },
    { label: "NOMBRE DEL JEFE INMEDIATO:", id: "jefe-inmediato" },
    { label: "PUESTO DEL JEFE INMEDIATO:", id: "puesto-jefe" },
    { label: "FECHA DE INGRESO:", id: "fecha-ingreso" },
    { label: "PUESTO INICIAL:", id: "puesto-inicial" },
    { label: "SUELDO INICIAL:", id: "sueldo-inicial" },
    { label: "PUESTO FINAL:", id: "puesto-final" },
    { label: "SUELDO FINAL:", id: "sueldo-final" },
    { label: "FECHA DE SALIDA:", id: "fecha-salida" },
    { label: "MOTIVO DE LA SEPARACIÓN:", id: "motivo-separacion" },
  ];

  const [formData, setFormData] = useState({});

  const handleInputChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const calcularEdad = (fechaNacimiento: string) => {
    const fechaNac = new Date(fechaNacimiento);
    const hoy = new Date();
    let edadCalculada = hoy.getFullYear() - fechaNac.getFullYear();
    const mes = hoy.getMonth() - fechaNac.getMonth();

    if (mes < 0 || (mes === 0 && hoy.getDate() < fechaNac.getDate())) {
      edadCalculada--;
    }

    return edadCalculada;
  };

  const handleFechaNacimientoChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const nuevaFechaNacimiento = event.target.value;
    setFechaNacimiento(nuevaFechaNacimiento);

    const nuevaEdad = calcularEdad(nuevaFechaNacimiento);
    setEdad(nuevaEdad);
  };

  const queryEvaluado = useGetData<EvaluadoInterface>({
    url: `/evaluado/${evaluadosList_id}`,
    name: ["evaluado"],
  });

  const queryFecha = useGetData<FechasInterface[]>({
    url: `/evaluado/${evaluadosList_id}/fecha-visita-bienesinmuebles`,
    name: ["fecha-visita-bienesinmuebles"],
  });

  const queryLaborales = useGetData<ReferenciasLaboralesInterface>({
    url: `/referencia-laboral/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "referencia-laboral"],
  });

  const queryNotasRL = useGetData<NotasRLInterface[]>({
    url: `/notas_rl/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "notas_rl"],
  });

  const generoMap: { [key: string]: string } = {
    M: "Masculino",
    F: "Femenino",
    O: "Otro",
  };

  const generoTexto =
    generoMap[queryEvaluado.data?.genero as string] || "No especificado";

  useEffect(() => {
    console.log(queryEvaluado.data);
    if (queryEvaluado.data) {
      const fechaNac = queryEvaluado.data.fecha_nacimiento || "";
      setFechaNacimiento(fechaNac);

      const nuevaEdad = calcularEdad(fechaNac);
      setEdad(nuevaEdad);

      reset({
        nombre: queryEvaluado.data.nombre || "",
        apellido_paterno: queryEvaluado.data.apellido_paterno || "",
        apellido_materno: queryEvaluado.data.apellido_materno || "",
        rfc: queryEvaluado.data.rfc || "",
        genero: queryEvaluado.data.genero || "",
        estado_civil: queryEvaluado.data.estado_civil || "",
        escolaridad: queryEvaluado.data.escolaridad || "",
        fecha_nacimiento: queryEvaluado.data.fecha_nacimiento || "",
        curp: queryEvaluado.data.curp || "",
        empresa: queryEvaluado.data.empresa?.nombre || "",
      });
    }
  }, [queryEvaluado.data, reset]);

  useEffect(() => {
    if (queryLaborales.data) {
      const rl = queryLaborales.data;
      reset({
        empresa_rl1: rl.empresa_rl1 || "",
        domicilio_rl1: rl.domicilio_rl1 || "",
        telefono_rl1: rl.telefono_rl1 || "",
        nombre_jefe_rl1: rl.nombre_jefe_rl1 || "",
        puesto_jefe_rl1: rl.puesto_jefe_rl1 || "",
        fecha_ingreso_rl1: rl.fecha_ingreso_rl1 || "",
        puesto_inicial_rl1: rl.puesto_inicial_rl1 || "",
        sueldo_inicial_rl1: rl.sueldo_inicial_rl1 || "",
        puesto_final_rl1: rl.puesto_final_rl1 || "",
        sueldo_final_rl1: rl.sueldo_final_rl1 || "",
        fecha_salida_rl1: rl.fecha_salida_rl1 || "",
        motivo_separacion_rl1: rl.motivo_separacion_rl1 || "",
        empresa_rl2: rl.empresa_rl2 || "",
        domicilio_rl2: rl.domicilio_rl2 || "",
        telefono_rl2: rl.telefono_rl2 || "",
        nombre_jefe_rl2: rl.nombre_jefe_rl2 || "",
        puesto_jefe_rl2: rl.puesto_jefe_rl2 || "",
        fecha_ingreso_rl2: rl.fecha_ingreso_rl2 || "",
        puesto_inicial_rl2: rl.puesto_inicial_rl2 || "",
        sueldo_inicial_rl2: rl.sueldo_inicial_rl2 || "",
        puesto_final_rl2: rl.puesto_final_rl2 || "",
        sueldo_final_rl2: rl.sueldo_final_rl2 || "",
        fecha_salida_rl2: rl.fecha_salida_rl2 || "",
        motivo_separacion_rl2: rl.motivo_separacion_rl2 || "",
        empresa_rl3: rl.empresa_rl3 || "",
        domicilio_rl3: rl.domicilio_rl3 || "",
        telefono_rl3: rl.telefono_rl3 || "",
        nombre_jefe_rl3: rl.nombre_jefe_rl3 || "",
        puesto_jefe_rl3: rl.puesto_jefe_rl3 || "",
        fecha_ingreso_rl3: rl.fecha_ingreso_rl3 || "",
        puesto_inicial_rl3: rl.puesto_inicial_rl3 || "",
        sueldo_inicial_rl3: rl.sueldo_inicial_rl3 || "",
        puesto_final_rl3: rl.puesto_final_rl3 || "",
        sueldo_final_rl3: rl.sueldo_final_rl3 || "",
        fecha_salida_rl3: rl.fecha_salida_rl3 || "",
        motivo_separacion_rl3: rl.motivo_separacion_rl3 || "",
      });
    }
  }, [queryLaborales.data, reset]);

  useEffect(() => {
    if (queryNotasRL.data && queryNotasRL.data.length > 0) {
      const registroValido = queryNotasRL.data.find((item) => item.nota_rl);

      if (registroValido) {
        setValue("nota_rl", registroValido.nota_rl);
      }
    }
  }, [queryNotasRL.data, setValue]);

  return (
    <div className="max-w-[800px] mx-auto p-4 bg-white">
      {/* Marca de agua */}
      <div className="absolute inset-0 flex justify-center items-center pointer-events-none z-0">
        <div
          className="text-blue-500 text-9xl font-bold transform rotate-[-48deg]"
          style={{ opacity: 0.1 }}
        >
          CONFIDENCIAL
        </div>
      </div>
      {/* Header */}
      <HeaderPrint titulo={tituloFormulario} />
      {/* Título del formulario */}
      <div id="headerContent" className="text-center">
        <h1
          className="text-black text-xl font-bold py-3 px-8 rounded-b-md inline-block shadow-lg flex justify-center transition-transform duration-300 ease-in-out hover:scale-105 cursor-pointer"
          style={{
            backgroundImage: `url(${fotoMapa})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          {tituloFormulario}
        </h1>
      </div>
      <div className="space-y-1 p-1 mt-2">
        <div className="grid grid-cols-3 gap-2">
          <div className="col-span-1 flex items-center">
            <Label htmlFor="fecha_bienesinmuebles" className="mr-2">
              FECHA VISITA:
            </Label>
            <Controller
              name="fecha_refl"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <TextInput
                  id="fecha_refl"
                  name="fecha_refl"
                  type="date"
                  value={
                    queryFecha.data && queryFecha.data.length > 0
                      ? queryFecha.data[0].fecha_refl || ""
                      : ""
                  }
                  disabled={true}
                />
              )}
            />
          </div>
          <div className="col-span-2">
            <Label htmlFor="nombre">NOMBRE:</Label>
            <TextInput
              id="nombre"
              name="nombre"
              value={`${queryEvaluado.data?.nombre || ""} ${
                queryEvaluado.data?.apellido_paterno || ""
              } ${queryEvaluado.data?.apellido_materno || ""}`}
              onChange={handleInputChange}
              disabled={true}
            />
          </div>
          {/* Campo para RFC */}
          <div className="col-span-1">
            <Label htmlFor="rfc">RFC:</Label>
            <TextInput
              id="rfc"
              name="rfc"
              onChange={handleInputChange}
              value={queryEvaluado.data?.rfc || ""}
              disabled={true}
            />
          </div>
          {/* Edad */}
          <div className="col-span-1">
            <Label htmlFor="edad">EDAD:</Label>
            <TextInput
              id="edad"
              name="edad"
              value={edad !== null ? edad.toString() : ""}
              disabled={true}
            />
          </div>
          <div className="col-span-1">
            <Label htmlFor="sexo">SEXO:</Label>
            <TextInput
              id="sexo"
              name="sexo"
              value={generoTexto}
              disabled={true}
            />
          </div>
          <div className="col-span-1">
            <Label htmlFor="estadoCivil">ESTADO CIVIL:</Label>
            <TextInput
              id="estadoCivil"
              name="estadoCivil"
              onChange={handleInputChange}
              value={`${queryEvaluado.data?.estado_civil || ""}`}
              disabled={true}
            />
          </div>
          <div className="col-span-1">
            <Label htmlFor="escolaridad">ESCOLARIDAD:</Label>
            <TextInput
              id="escolaridad"
              name="escolaridad"
              onChange={handleInputChange}
              value={`${queryEvaluado.data?.escolaridad || ""}`}
              disabled={true}
            />
          </div>
          <div className="col-span-1 flex items-center">
            <Label htmlFor="fechaNacimiento" className="mr-2">
              FECHA DE NACIMIENTO:
            </Label>
            <TextInput
              id="fechaNacimiento"
              name="fechaNacimiento"
              value={`${queryEvaluado.data?.fecha_nacimiento || ""}`}
              disabled={true}
              type="date"
              onChange={handleInputChange}
              className="w-32"
            />
          </div>
          <div className="col-span-1">
            <Label htmlFor="curp">CURP:</Label>
            <TextInput
              id="curp"
              name="curp"
              onChange={handleInputChange}
              value={queryEvaluado.data?.curp || ""}
              disabled={true}
            />
          </div>
          <div className="col-span-1">
            <Label htmlFor="empresa">EMPRESA:</Label>
            <TextInput
              id="empresa_id"
              name="empresa"
              value={queryEvaluado.data?.empresa_id?.nombre || ""}
              onChange={handleInputChange}
              disabled={true}
            />
          </div>
        </div>
      </div>
      <div className="bg-slate-100 p-0.5 rounded-lg mt-2">
        <img
          src={BarraReferenciaL}
          alt="HeaderDatosGenerales"
          className="rounded-lg h-auto max-h-20"
        />
      </div>
      <div className="bg-blue-100 text-center font-semibold text-gray-700 border-b border-gray-300">
        REFERENCIA LABORAL 1
      </div>
      <div className="relative">
        <table className="w-full border-collapse">
          <tbody>
            <tr>
              <td className="border border-gray-300 p-0.5 font-semibold w-3/4 text-xs">
                EMPRESA:{" "}
              </td>
              <td className="border border-gray-300 p-0.5 text-xs">
                <Controller
                  name="empresa_rl1"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      type="text"
                      id="empresa_rl1"
                      value={
                        field.value || queryLaborales.data?.empresa_rl1 || ""
                      }
                      disabled={true}
                      onChange={(e) => field.onChange(e.target.value)}
                      className="text-left w-auto border rounded text-xs leading-tight"
                    />
                  )}
                />
              </td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-0.5 font-semibold w-3/4 text-xs">
                DOMICILIO:{" "}
              </td>
              <td className="border border-gray-300 p-0.5 text-xs">
                <Controller
                  name="domicilio_rl1"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      type="text"
                      id="domicilio_rl1"
                      value={
                        field.value || queryLaborales.data?.domicilio_rl1 || ""
                      }
                      disabled={true}
                      onChange={(e) => field.onChange(e.target.value)}
                      className="text-left w-auto border rounded text-xs leading-tight"
                    />
                  )}
                />
              </td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-0.5 font-semibold w-3/4 text-xs">
                TELÉFONO:{" "}
              </td>
              <td className="border border-gray-300 p-0.5 text-xs">
                <Controller
                  name="telefono_rl1"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      type="text"
                      id="telefono_rl1"
                      value={
                        field.value || queryLaborales.data?.telefono_rl1 || ""
                      }
                      disabled={true}
                      onChange={(e) => field.onChange(e.target.value)}
                      className="text-left w-auto border rounded text-xs leading-tight"
                    />
                  )}
                />
              </td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-0.5 font-semibold w-3/4 text-xs">
                NOMBRE DEL JEFE INMEDIATO:{" "}
              </td>
              <td className="border border-gray-300 p-0.5 text-xs">
                <Controller
                  name="nombre_jefe_rl1"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      type="text"
                      id="nombre_jefe_rl1"
                      value={
                        field.value ||
                        queryLaborales.data?.nombre_jefe_rl1 ||
                        ""
                      }
                      disabled={true}
                      onChange={(e) => field.onChange(e.target.value)}
                      className="text-left w-auto border rounded text-xs leading-tight"
                    />
                  )}
                />
              </td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-0.5 font-semibold w-3/4 text-xs">
                PUESTO DEL JEFE INMEDIATO:{" "}
              </td>
              <td className="border border-gray-300 p-0.5 text-xs">
                <Controller
                  name="puesto_jefe_rl1"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      type="text"
                      id="puesto_jefe_rl1"
                      value={
                        field.value ||
                        queryLaborales.data?.puesto_jefe_rl1 ||
                        ""
                      }
                      disabled={true}
                      onChange={(e) => field.onChange(e.target.value)}
                      className="text-left w-auto border rounded text-xs leading-tight"
                    />
                  )}
                />
              </td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-0.5 font-semibold w-3/4 text-xs">
                FECHA DE INGRESO:{" "}
              </td>
              <td className="border border-gray-300 p-0.5 text-xs">
                <Controller
                  name="fecha_ingreso_rl1"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      type="date"
                      id="fecha_ingreso_rl1"
                      value={
                        field.value ||
                        queryLaborales.data?.fecha_ingreso_rl1 ||
                        ""
                      }
                      disabled={true}
                      onChange={(e) => field.onChange(e.target.value)}
                      className="text-left w-auto border rounded text-xs leading-tight"
                    />
                  )}
                />
              </td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-0.5 font-semibold w-3/4 text-xs">
                PUESTO INICIAL:{" "}
              </td>
              <td className="border border-gray-300 p-0.5 text-xs">
                <Controller
                  name="puesto_inicial_rl1"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      type="text"
                      id="puesto_inicial_rl1"
                      value={
                        field.value ||
                        queryLaborales.data?.puesto_inicial_rl1 ||
                        ""
                      }
                      disabled={true}
                      onChange={(e) => field.onChange(e.target.value)}
                      className="text-left w-auto border rounded text-xs leading-tight"
                    />
                  )}
                />
              </td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-0.5 font-semibold w-3/4 text-xs">
                SUELDO INICIAL:{" "}
              </td>
              <td className="border border-gray-300 p-0.5 text-xs">
                <Controller
                  name="sueldo_inicial_rl1"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      type="text"
                      id="sueldo_inicial_rl1"
                      value={
                        field.value ||
                        queryLaborales.data?.sueldo_inicial_rl1 ||
                        ""
                      }
                      disabled={true}
                      onChange={(e) => field.onChange(e.target.value)}
                      className="text-left w-auto border rounded text-xs leading-tight"
                    />
                  )}
                />
              </td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-0.5 font-semibold w-3/4 text-xs">
                PUESTO FINAL:{" "}
              </td>
              <td className="border border-gray-300 p-0.5 text-xs">
                <Controller
                  name="puesto_final_rl1"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      type="text"
                      id="puesto_final_rl1"
                      value={
                        field.value ||
                        queryLaborales.data?.puesto_final_rl1 ||
                        ""
                      }
                      disabled={true}
                      onChange={(e) => field.onChange(e.target.value)}
                      className="text-left w-auto border rounded text-xs leading-tight"
                    />
                  )}
                />
              </td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-0.5 font-semibold w-3/4 text-xs">
                SUELDO FINAL:{" "}
              </td>
              <td className="border border-gray-300 p-0.5 text-xs">
                <Controller
                  name="sueldo_final_rl1"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      type="text"
                      id="sueldo_final_rl1"
                      value={
                        field.value ||
                        queryLaborales.data?.sueldo_final_rl1 ||
                        ""
                      }
                      disabled={true}
                      onChange={(e) => field.onChange(e.target.value)}
                      className="text-left w-auto border rounded text-xs leading-tight"
                    />
                  )}
                />
              </td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-0.5 font-semibold w-3/4 text-xs">
                FECHA DE SALIDA:{" "}
              </td>
              <td className="border border-gray-300 p-0.5 text-xs">
                <Controller
                  name="fecha_salida_rl1"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      type="date"
                      id="fecha_salida_rl1"
                      value={
                        field.value ||
                        queryLaborales.data?.fecha_salida_rl1 ||
                        ""
                      }
                      disabled={true}
                      onChange={(e) => field.onChange(e.target.value)}
                      className="text-left w-auto border rounded text-xs leading-tight"
                    />
                  )}
                />
              </td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-0.5 font-semibold w-3/4 text-xs">
                MOTIVO DE LA SEPARACIÓN:{" "}
              </td>
              <td className="border border-gray-300 p-0.5 text-xs">
                <Controller
                  name="motivo_separacion_rl1"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      type="text"
                      id="motivo_separacion_rl1"
                      value={
                        field.value ||
                        queryLaborales.data?.motivo_separacion_rl1 ||
                        ""
                      }
                      disabled={true}
                      onChange={(e) => field.onChange(e.target.value)}
                      className="text-left w-auto border rounded text-xs leading-tight"
                    />
                  )}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="bg-blue-100 text-center font-semibold text-gray-700 border-b border-gray-300">
        REFERENCIA LABORAL 2
      </div>
      <div className="relative">
        <table className="w-full border-collapse">
          <tbody>
            <tr>
              <td className="border border-gray-300 p-0.5 font-semibold w-3/4 text-xs">
                EMPRESA:{" "}
              </td>
              <td className="border border-gray-300 p-0.5 text-xs">
                <Controller
                  name="empresa_rl2"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      type="text"
                      id="empresa_rl2"
                      value={
                        field.value || queryLaborales.data?.empresa_rl2 || ""
                      }
                      disabled={true}
                      onChange={(e) => field.onChange(e.target.value)}
                      className="text-left w-auto border rounded text-xs leading-tight"
                    />
                  )}
                />
              </td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-0.5 font-semibold w-3/4 text-xs">
                DOMICILIO:{" "}
              </td>
              <td className="border border-gray-300 p-0.5 text-xs">
                <Controller
                  name="domicilio_rl2"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      type="text"
                      id="domicilio_rl2"
                      value={
                        field.value || queryLaborales.data?.domicilio_rl2 || ""
                      }
                      disabled={true}
                      onChange={(e) => field.onChange(e.target.value)}
                      className="text-left w-auto border rounded text-xs leading-tight"
                    />
                  )}
                />
              </td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-0.5 font-semibold w-3/4 text-xs">
                TELÉFONO:{" "}
              </td>
              <td className="border border-gray-300 p-0.5 text-xs">
                <Controller
                  name="telefono_rl2"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      type="text"
                      id="telefono_rl2"
                      value={
                        field.value || queryLaborales.data?.telefono_rl2 || ""
                      }
                      disabled={true}
                      onChange={(e) => field.onChange(e.target.value)}
                      className="text-left w-auto border rounded text-xs leading-tight"
                    />
                  )}
                />
              </td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-0.5 font-semibold w-3/4 text-xs">
                NOMBRE DEL JEFE INMEDIATO:{" "}
              </td>
              <td className="border border-gray-300 p-0.5 text-xs">
                <Controller
                  name="nombre_jefe_rl2"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      type="text"
                      id="nombre_jefe_rl1"
                      value={
                        field.value ||
                        queryLaborales.data?.nombre_jefe_rl2 ||
                        ""
                      }
                      disabled={true}
                      onChange={(e) => field.onChange(e.target.value)}
                      className="text-left w-auto border rounded text-xs leading-tight"
                    />
                  )}
                />
              </td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-0.5 font-semibold w-3/4 text-xs">
                PUESTO DEL JEFE INMEDIATO:{" "}
              </td>
              <td className="border border-gray-300 p-0.5 text-xs">
                <Controller
                  name="puesto_jefe_rl2"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      type="text"
                      id="puesto_jefe_rl2"
                      value={
                        field.value ||
                        queryLaborales.data?.puesto_jefe_rl2 ||
                        ""
                      }
                      disabled={true}
                      onChange={(e) => field.onChange(e.target.value)}
                      className="text-left w-auto border rounded text-xs leading-tight"
                    />
                  )}
                />
              </td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-0.5 font-semibold w-3/4 text-xs">
                FECHA DE INGRESO:{" "}
              </td>
              <td className="border border-gray-300 p-0.5 text-xs">
                <Controller
                  name="fecha_ingreso_rl2"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      type="date"
                      id="fecha_ingreso_rl2"
                      value={
                        field.value ||
                        queryLaborales.data?.fecha_ingreso_rl2 ||
                        ""
                      }
                      disabled={true}
                      onChange={(e) => field.onChange(e.target.value)}
                      className="text-left w-auto border rounded text-xs leading-tight"
                    />
                  )}
                />
              </td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-0.5 font-semibold w-3/4 text-xs">
                PUESTO INICIAL:{" "}
              </td>
              <td className="border border-gray-300 p-0.5 text-xs">
                <Controller
                  name="puesto_inicial_rl2"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      type="text"
                      id="puesto_inicial_rl2"
                      value={
                        field.value ||
                        queryLaborales.data?.puesto_inicial_rl2 ||
                        ""
                      }
                      disabled={true}
                      onChange={(e) => field.onChange(e.target.value)}
                      className="text-left w-auto border rounded text-xs leading-tight"
                    />
                  )}
                />
              </td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-0.5 font-semibold w-3/4 text-xs">
                SUELDO INICIAL:{" "}
              </td>
              <td className="border border-gray-300 p-0.5 text-xs">
                <Controller
                  name="sueldo_inicial_rl2"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      type="text"
                      id="sueldo_inicial_rl2"
                      value={
                        field.value ||
                        queryLaborales.data?.sueldo_inicial_rl2 ||
                        ""
                      }
                      disabled={true}
                      onChange={(e) => field.onChange(e.target.value)}
                      className="text-left w-auto border rounded text-xs leading-tight"
                    />
                  )}
                />
              </td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-0.5 font-semibold w-3/4 text-xs">
                PUESTO FINAL:{" "}
              </td>
              <td className="border border-gray-300 p-0.5 text-xs">
                <Controller
                  name="puesto_final_rl2"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      type="text"
                      id="puesto_final_rl2"
                      value={
                        field.value ||
                        queryLaborales.data?.puesto_final_rl2 ||
                        ""
                      }
                      disabled={true}
                      onChange={(e) => field.onChange(e.target.value)}
                      className="text-left w-auto border rounded text-xs leading-tight"
                    />
                  )}
                />
              </td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-0.5 font-semibold w-3/4 text-xs">
                SUELDO FINAL:{" "}
              </td>
              <td className="border border-gray-300 p-0.5 text-xs">
                <Controller
                  name="sueldo_final_rl2"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      type="text"
                      id="sueldo_final_rl2"
                      value={
                        field.value ||
                        queryLaborales.data?.sueldo_final_rl2 ||
                        ""
                      }
                      disabled={true}
                      onChange={(e) => field.onChange(e.target.value)}
                      className="text-left w-auto border rounded text-xs leading-tight"
                    />
                  )}
                />
              </td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-0.5 font-semibold w-3/4 text-xs">
                FECHA DE SALIDA:{" "}
              </td>
              <td className="border border-gray-300 p-0.5 text-xs">
                <Controller
                  name="fecha_salida_rl2"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      type="date"
                      id="fecha_salida_rl2"
                      value={
                        field.value ||
                        queryLaborales.data?.fecha_salida_rl2 ||
                        ""
                      }
                      disabled={true}
                      onChange={(e) => field.onChange(e.target.value)}
                      className="text-left w-auto border rounded text-xs leading-tight"
                    />
                  )}
                />
              </td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-0.5 font-semibold w-3/4 text-xs">
                MOTIVO DE LA SEPARACIÓN:{" "}
              </td>
              <td className="border border-gray-300 p-0.5 text-xs">
                <Controller
                  name="motivo_separacion_rl2"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      type="text"
                      id="motivo_separacion_rl2"
                      value={
                        field.value ||
                        queryLaborales.data?.motivo_separacion_rl2 ||
                        ""
                      }
                      disabled={true}
                      onChange={(e) => field.onChange(e.target.value)}
                      className="text-left w-auto border rounded text-xs leading-tight"
                    />
                  )}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="mt-[400px]"></div>
      <div className="bg-blue-100 text-center font-semibold text-gray-700 border-b border-gray-300">
        REFERENCIA LABORAL 3
      </div>
      <div className="relative">
        <table className="w-full border-collapse">
          <tbody>
            <tr>
              <td className="border border-gray-300 p-0.5 font-semibold w-3/4 text-xs">
                EMPRESA:{" "}
              </td>
              <td className="border border-gray-300 p-0.5 text-xs">
                <Controller
                  name="empresa_rl3"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      type="text"
                      id="empresa_rl3"
                      value={
                        field.value || queryLaborales.data?.empresa_rl3 || ""
                      }
                      disabled={true}
                      onChange={(e) => field.onChange(e.target.value)}
                      className="text-left w-auto border rounded text-xs leading-tight"
                    />
                  )}
                />
              </td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-0.5 font-semibold w-3/4 text-xs">
                DOMICILIO:{" "}
              </td>
              <td className="border border-gray-300 p-0.5 text-xs">
                <Controller
                  name="domicilio_rl3"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      type="text"
                      id="domicilio_rl3"
                      value={
                        field.value || queryLaborales.data?.domicilio_rl3 || ""
                      }
                      disabled={true}
                      onChange={(e) => field.onChange(e.target.value)}
                      className="text-left w-auto border rounded text-xs leading-tight"
                    />
                  )}
                />
              </td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-0.5 font-semibold w-3/4 text-xs">
                TELÉFONO:{" "}
              </td>
              <td className="border border-gray-300 p-0.5 text-xs">
                <Controller
                  name="telefono_rl3"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      type="text"
                      id="telefono_rl3"
                      value={
                        field.value || queryLaborales.data?.telefono_rl3 || ""
                      }
                      disabled={true}
                      onChange={(e) => field.onChange(e.target.value)}
                      className="text-left w-auto border rounded text-xs leading-tight"
                    />
                  )}
                />
              </td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-0.5 font-semibold w-3/4 text-xs">
                NOMBRE DEL JEFE INMEDIATO:{" "}
              </td>
              <td className="border border-gray-300 p-0.5 text-xs">
                <Controller
                  name="nombre_jefe_rl3"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      type="text"
                      id="nombre_jefe_rl3"
                      value={
                        field.value ||
                        queryLaborales.data?.nombre_jefe_rl3 ||
                        ""
                      }
                      disabled={true}
                      onChange={(e) => field.onChange(e.target.value)}
                      className="text-left w-auto border rounded text-xs leading-tight"
                    />
                  )}
                />
              </td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-0.5 font-semibold w-3/4 text-xs">
                PUESTO DEL JEFE INMEDIATO:{" "}
              </td>
              <td className="border border-gray-300 p-0.5 text-xs">
                <Controller
                  name="puesto_jefe_rl3"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      type="text"
                      id="puesto_jefe_rl3"
                      value={
                        field.value ||
                        queryLaborales.data?.puesto_jefe_rl3 ||
                        ""
                      }
                      disabled={true}
                      onChange={(e) => field.onChange(e.target.value)}
                      className="text-left w-auto border rounded text-xs leading-tight"
                    />
                  )}
                />
              </td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-0.5 font-semibold w-3/4 text-xs">
                FECHA DE INGRESO:{" "}
              </td>
              <td className="border border-gray-300 p-0.5 text-xs">
                <Controller
                  name="fecha_ingreso_rl3"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      type="date"
                      id="fecha_ingreso_rl3"
                      value={
                        field.value ||
                        queryLaborales.data?.fecha_ingreso_rl3 ||
                        ""
                      }
                      disabled={true}
                      onChange={(e) => field.onChange(e.target.value)}
                      className="text-left w-auto border rounded text-xs leading-tight"
                    />
                  )}
                />
              </td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-0.5 font-semibold w-3/4 text-xs">
                PUESTO INICIAL:{" "}
              </td>
              <td className="border border-gray-300 p-0.5 text-xs">
                <Controller
                  name="puesto_inicial_rl3"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      type="text"
                      id="puesto_inicial_rl3"
                      value={
                        field.value ||
                        queryLaborales.data?.puesto_inicial_rl3 ||
                        ""
                      }
                      disabled={true}
                      onChange={(e) => field.onChange(e.target.value)}
                      className="text-left w-auto border rounded text-xs leading-tight"
                    />
                  )}
                />
              </td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-0.5 font-semibold w-3/4 text-xs">
                SUELDO INICIAL:{" "}
              </td>
              <td className="border border-gray-300 p-0.5 text-xs">
                <Controller
                  name="sueldo_inicial_rl3"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      type="text"
                      id="sueldo_inicial_rl3"
                      value={
                        field.value ||
                        queryLaborales.data?.sueldo_inicial_rl3 ||
                        ""
                      }
                      disabled={true}
                      onChange={(e) => field.onChange(e.target.value)}
                      className="text-left w-auto border rounded text-xs leading-tight"
                    />
                  )}
                />
              </td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-0.5 font-semibold w-3/4 text-xs">
                PUESTO FINAL:{" "}
              </td>
              <td className="border border-gray-300 p-0.5 text-xs">
                <Controller
                  name="puesto_final_rl3"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      type="text"
                      id="puesto_final_rl3"
                      value={
                        field.value ||
                        queryLaborales.data?.puesto_final_rl3 ||
                        ""
                      }
                      disabled={true}
                      onChange={(e) => field.onChange(e.target.value)}
                      className="text-left w-auto border rounded text-xs leading-tight"
                    />
                  )}
                />
              </td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-0.5 font-semibold w-3/4 text-xs">
                SUELDO FINAL:{" "}
              </td>
              <td className="border border-gray-300 p-0.5 text-xs">
                <Controller
                  name="sueldo_final_rl3"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      type="text"
                      id="sueldo_final_rl3"
                      value={
                        field.value ||
                        queryLaborales.data?.sueldo_final_rl3 ||
                        ""
                      }
                      disabled={true}
                      onChange={(e) => field.onChange(e.target.value)}
                      className="text-left w-auto border rounded text-xs leading-tight"
                    />
                  )}
                />
              </td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-0.5 font-semibold w-3/4 text-xs">
                FECHA DE SALIDA:{" "}
              </td>
              <td className="border border-gray-300 p-0.5 text-xs">
                <Controller
                  name="fecha_salida_rl3"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      type="date"
                      id="fecha_salida_rl3"
                      value={
                        field.value ||
                        queryLaborales.data?.fecha_salida_rl3 ||
                        ""
                      }
                      disabled={true}
                      onChange={(e) => field.onChange(e.target.value)}
                      className="text-left w-auto border rounded text-xs leading-tight"
                    />
                  )}
                />
              </td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-0.5 font-semibold w-3/4 text-xs">
                MOTIVO DE LA SEPARACIÓN:{" "}
              </td>
              <td className="border border-gray-300 p-0.5 text-xs">
                <Controller
                  name="motivo_separacion_rl3"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      type="text"
                      id="motivo_separacion_rl3"
                      value={
                        field.value ||
                        queryLaborales.data?.motivo_separacion_rl3 ||
                        ""
                      }
                      disabled={true}
                      onChange={(e) => field.onChange(e.target.value)}
                      className="text-left w-auto border rounded text-xs leading-tight"
                    />
                  )}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="mt-[300px]"></div>
      <div className="p-4 border-t border-gray-300">
        <div className="text-center">
          <p className="text-left text-xs text-gray-600">
            Bajo protesta de decir verdad, hago constar que los datos
            proporcionados son verdaderos. Asimismo, autorizo a la empresa SKA
            TRACKING AND SECURITY S.A. de C.V. para que proporcione toda la
            información, documentos y todos los datos que derive de las
            evaluaciones de pruebas de confianza que se me realicen.
          </p>
        </div>
        <div className="flex justify-end">
          <p className="text-right text-xs text-gray-600">
            ___________________________
            <br />
            Nombre y Firma del Evaluado
          </p>
        </div>
      </div>
      {/* Header */}
      <HeaderPrint titulo={tituloFormulario} />
      {/* Título del formulario */}
      <div id="headerContent" className="text-center">
        <h1
          className="text-black text-xl font-bold py-3 px-8 rounded-b-md inline-block shadow-lg flex justify-center transition-transform duration-300 ease-in-out hover:scale-105 cursor-pointer"
          style={{
            backgroundImage: `url(${fotoMapa})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          {tituloFormulario}
        </h1>
      </div>
      {/* Marca de agua */}
      <div className="absolute inset-0 top-[150%] flex justify-center items-center pointer-events-none z-0">
        <div
          className="text-blue-500 text-9xl font-bold transform rotate-[-48deg]"
          style={{ opacity: 0.1 }}
        >
          CONFIDENCIAL
        </div>
      </div>
      {/* Marca de agua */}
      <div className="absolute inset-0 top-[250%] flex justify-center items-center pointer-events-none z-0">
        <div
          className="text-blue-500 text-9xl font-bold transform rotate-[-48deg]"
          style={{ opacity: 0.1 }}
        >
          CONFIDENCIAL
        </div>
      </div>
      {/* Marca de agua */}
      <div className="absolute inset-0 top-[350%] flex justify-center items-center pointer-events-none z-0">
        <div
          className="text-blue-500 text-9xl font-bold transform rotate-[-48deg]"
          style={{ opacity: 0.1 }}
        >
          CONFIDENCIAL
        </div>
      </div>
      {/* Sección de Notas */}
      <div className="border border-gray-300 mt-4">
        <div className="bg-blue-100 p-2 text-center font-semibold text-gray-700 border-b border-gray-300">
          NOTAS
        </div>
        <Controller
          name="nota_rp"
          control={control}
          defaultValue=""
          render={({ field }) => (
            <textarea
              className="w-full p-2 min-h-[100px] text-sm text-gray-900 border-0 focus:ring-0 resize-none"
              aria-label="Notes"
              {...field}
              value={
                field.value ||
                (queryNotasRL.data && queryNotasRL.data.length > 0
                  ? queryNotasRL.data[0]?.nota_rl || ""
                  : "")
              }
              onInput={(e) => {
                const target = e.target as HTMLTextAreaElement;
                target.style.height = "auto";
                target.style.height = `${target.scrollHeight}px`;
              }}
              style={{ height: "auto", overflow: "hidden" }}
            />
          )}
        />
      </div>
      <div className="mt-[450px]"></div>
      <div className="p-4 border-t border-gray-300">
        <div className="text-center">
          <p className="text-left text-xs text-gray-600">
            Bajo protesta de decir verdad, hago constar que los datos
            proporcionados son verdaderos. Asimismo, autorizo a la empresa SKA
            TRACKING AND SECURITY S.A. de C.V. para que proporcione toda la
            información, documentos y todos los datos que derive de las
            evaluaciones de pruebas de confianza que se me realicen.
          </p>
        </div>
        <div className="flex justify-end">
          <p className="text-right text-xs text-gray-600">
            ___________________________
            <br />
            Nombre y Firma del Evaluado
          </p>
        </div>
      </div>
    </div>
  );
};
